import { gql } from '@apollo/client'

import { MENU_DATA_FRAGMENT } from '../fragments'

const MENU_DATA_QUERY = gql`
  query menuData($menuCurationTaskId: ID!) {
    menuData(menuCurationTaskId: $menuCurationTaskId) {
      ...MenuDataFragment
    }
  }
  ${MENU_DATA_FRAGMENT}
`

export default MENU_DATA_QUERY
